var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M15.5 10.6c0-3.1 2.5-5.7 5.7-5.7h11M39.4 12.1v6M32.2 5l7.1 7.1M31.3 6.2V13h7.1M15.1 16.6l5.5 5.5-5.5 5.5M19 22.1H7.3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 2.5,
    cy: 22.1,
    r: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M39 30.8H21.9v6.5H39V24.5h-8.3l-.2 12.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportExcel);
export default __webpack_public_path__ + "static/media/exportExcel.f2cd1d2adfc555660777033d776ef4c0.svg";
export { ForwardRef as ReactComponent };